
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
  },
  data: function () {
    //console.log(this);
    var contract = this.$route.context.contract;
    console.log(contract); //            var currentArticle;
    //            this.$root.news.forEach(function (article) {
    //                if (article.id === articleId) {
    //                    currentArticle = article;
    //                }
    //            });

    return {
      contract: contract
    };
  },
  id: 'e26f7e59de',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="contract">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">\n                        ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.backButton, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        My Mitsu\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += c(ctx_2.backButton, ctx_2);
          r += '\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </span>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.contract.name, ctx_1);
      r += '</div>\n                <div class="right"></div>\n            </div>\n        </div>\n        <div class="page-content">\n           \n            <div class="block-title">Contract Details</div>\n            <div class="list">\n                <ul>\n                    <li>\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Name</div>\n                                    ';
      r += c(ctx_1.contract.name, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Validity</div>\n                                    ';
      r += c(ctx_1.contract.expiry, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Code</div>\n                                    ';
      r += c(ctx_1.contract.code, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title" style="white-space: normal">\n                                    <div class="item-footer">Type</div>\n                                    ';
      r += c(ctx_1.contract.material_label, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.contract.same_day_service, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li class="display-none">\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Same day service extra cost</div>\n                                    ';
          r += c(ctx_2.contract.same_day_cost_formatted, ctx_2);
          r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <li>\n                        <div  class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Customer</div>\n                                    ';
      r += c(ctx_1.contract.customer, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n            <div class="block-title">Units</div>\n            <div class="list notifications-list">\n                <ul>\n                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.contract.units, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li>\n                        <a href="/request-repair/';
          r += c(ctx_2.location_id, ctx_2);
          r += '/';
          r += c(ctx_2.id, ctx_2);
          r += '/" class="item-link item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    ';
          r += c(ctx_2.name, ctx_2);
          r += ' - ';
          r += c(ctx_2.code, ctx_2);
          r += '\n                                    <div class="item-footer">';
          r += c(ctx_2.location, ctx_2);
          r += '</div>\n                                </div>\n                                <div class="item-after">Request repair</div>\n                            </div>\n                        </a>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                </ul>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    